import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { UserService } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { GeoCoordinatorClientConfig } from './client-config';

@Injectable({
    providedIn: 'root',
})
export class GeoCoordinatorActivatorService {
    private readonly geolocationConfig: GeoCoordinatorClientConfig = inject(GeoCoordinatorClientConfig);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly user = inject(UserService);

    async isActive(): Promise<boolean> {
        await firstValueFrom(this.geolocationConfig.whenReady);

        return !this.isDisabledViaQueryParam() && this.isGeoLocationRestrictionEnabled();
    }

    async canSwitchOnLegacy(): Promise<boolean> {
        const isActive = await this.isActive();

        if (isActive) {
            const reqParamIdentifier = 'geoCoordination:switchOnLegacy';
            const hasReqParam = this.activatedRoute.snapshot.queryParamMap.has(reqParamIdentifier);
            const switchOnLegacyQueryParameter = this.activatedRoute.snapshot.queryParamMap.get(reqParamIdentifier);
            if (hasReqParam) {
                return switchOnLegacyQueryParameter?.toLowerCase() === 'true';
            }

            return this.geolocationConfig.switchOnLegacy;
        }
        throw new Error('canSwitchOnLegacy can be called only when GeoCoordination feature is enabled');
    }

    private isGeoLocationRestrictionEnabled(): boolean {
        return this.geolocationConfig.isEnabled && this.user.isAuthenticated;
    }

    private isDisabledViaQueryParam() {
        let isDisabledViaRoute = false;
        const disableFeaureQueryParameter = this.activatedRoute.snapshot.queryParamMap.get('_disableFeature');
        isDisabledViaRoute =
            disableFeaureQueryParameter
                ?.trim()
                ?.split(',')
                ?.some((queryParameterValue: string) => queryParameterValue?.toLowerCase() === 'geolocation') ?? false;

        return isDisabledViaRoute;
    }
}
